const COLOR_VARS = {
  SWIFT_COLOR1: '#3179F5',
  SWIFT_COLOR2: '#FF3888',
  SWIFT_COLOR3: '#36BEAD',
  SWIFT_COLOR4: 'rgba(1, 22, 39, 0.70)',
  SWIFT_COLOR5: '#CCCCCC',
  SWIFT_COLOR6: "#ffffff"
}

module.exports = {COLOR_VARS};